// Libs
import _size from 'lodash/size'
import _omitBy from 'lodash/omitBy'

export default function (state) {
  const permissions = state.permissions()

  return function composeReducers ({
    actionTypes,
    branch,
  }) {
    const reducerMap = {}

    reducerMap[actionTypes.receive()] = function receive (state, payload, action) {
      const { data } = payload

      if (_size(data)) {
        return {
          ...state,
          [branch]: {
            ...state[branch],
            ...data,
          },
        }
      }

      return state
    }

    if (permissions.delete) {
      reducerMap[actionTypes.deleted()] = function _delete (state, payload, action) {
        const { id } = payload

        return {
          ...state,
          [branch]: _omitBy(state[branch], function (model) {
            return model.id === id
          }),
        }
      }
    }

    return reducerMap
  }
}
